const data = {
  Experiences:[
    {
       id:1,
       title:"Sparks Foundation Internship",
       content:"Designed and implemented a banking system using React-Js. Developed an interactive money transfer facility between a dummy database of ten people",
       link: "https://github.com/dktomar9456/Sparks_Foundation/tree/master",
       webLink: "https://dktomar9456.github.io/Sparks_Foundation/",
       certificate:"https://truecertificates.com/verified/DNFL2WA54P",
       duration:"(Oct 2021 - Nov 2021)"
    }
  ],
  Projects: [
    {
      id: 1,
      title: "Quiz App",
      content:
        "Developed a quiz website using React-JS, in which users have an option to choose a quiz. And then, it provides an interface for the selected quiz.",
      link: "https://github.com/dktomar9456/Quiz_App/tree/master",
      webLink: "https://dktomar9456.github.io/Quiz_App/",
      duration: "(JULY 2021)",
    },
    {
      id: 2,
      title: "Web Portfolio",
      content:
        "Developed a web Portfolio. It contains all the information that is on this Resume. It uses a single component to store and Three components to render this information in a React app.",
      link: "https://github.com/dktomar9456/My_Portfolio/tree/master",
      webLink: "https://dktomar9456.github.io/My_Portfolio/",
      duration: "(JULY 2021)",
    },
    {
      id: 3,
      title: "Dress Color Combinations Webapp",
      content:
        "It is a working web app in which users can choose the color of upper and lower clothing and find the perfect color combination.",
      link: "https://github.com/dktomar9456/Dress_colour_combnation/tree/master",
      webLink: "https://dktomar9456.github.io/Dress_colour_combnation/",
      duration: "(JUNE 2021)",
    },
    
  ],
  Education: [
    {
      id: 1,
      title: "Indian Institute of Technology (ISM), Dhanbad",
      Class: "B.Tech, Petroleum Engineering",
      duration: "(July 2019 - May 2023)",
      performance: "[CGPA - 7.65]",
    },
    {
      id: 2,
      title: "Jawahar Navodaya Vidyalaya, Ghaziabad",
      Class: "12th Science ",
      duration: "(April 2017 - March 2018)",
      performance: "[93%]",
    },
    {
      id: 3,
      title: "Jawahar Navodaya Vidyalaya, Ghaziabad",
      Class: "10th ",
      duration: "(April 2015 - March 2016)",
      performance: "[CGPA - 9.6]",
    },
  ],
  Skills: [
    {
      id: 1,
      heading: "Languages: ",
      content: " C, C++, JavaScript",
    },
    {
      id: 2,
      heading: "Web Dev: ",
      content: " HTML, CSS, Bootstrap-5, React-JS",
    },
    {
      id: 3,
      heading: "Software Used: ",
      content: " Git , Sublime-Text , VS Code",
    },
    {
      id: 4,
      heading: "OS Used: ",
      content: " Linux, Windows",
    },
    {
      id: 5,
      heading: "Data structure And Algorithm",
    },
    {
      id: 6,
      heading: "Object-Oriented Programming",
    },
    {
      id: 7,
      heading: "Operating system & System Design",
    },
    {
      id: 8,
      heading: "English Professional Proficiency",
    },
  ],
  Achivements: [
    { id: 1, heading: "Global rank 108 in CodeChef March Lunchtime (Div-3)." },
    {
      id: 2,
      heading:
        "Ranked in top 1% among the 1.0 million aspirants in common merit list of IIT-JEE (Main + Advanced). ",
    },
    {
      id: 3,
      heading:
        "Qualified for GAIL Utkarsh Super 100 Kanpur and Dakshana scholarships.",
    },
  ],
  Extracurriculars: [
    {
      id: 1,
      heading:
        "I Like to play Hockey and I am an active member of Hockey Club (IIT ISM).",
    },
    { id: 2, heading: "I Like to swim and dance for recreational activities." },
  ],
  Por: [
    {
      id: 1,
      heading:
        "Organizer at HackFest21 (A 36 hours long annual hackathon at IIT ISM). ",
    },
    {
      id: 2,
      heading:
        "Active Member of ARKA Club (Astronomy club of IIT (ISM) Dhanbad)",
    },
  ],
};
export default data;
